module.exports = __webpack_public_path__ + "img/cuestionario-resultado.a5584db8.svg";